export default __webpack_public_path__ + "static/media/Graphik-RegularItalic.1bb44f45.otf";